<template>
  <div class="birthday-page">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss">
.birthday-page {
  width: 100%;
  height: 100vh;
  background-color: #f6f6f6;
  font-size: 32px;
  // #ef4c4f
  .flex-start {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header {
    .title {
      font-size: 32px;
      color: #333;
      font-weight: bold;
    }
    .tips {
      margin: 5px 0 20px 0;
      color: #666;
      font-size: 24px;
      font-weight: bold;
    }
  }
}
</style>